/**
 * @generated SignedSource<<40f15aa7638ad06f4b52fa8929e5405c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceDetail_space$data = {
  readonly alias: string | null;
  readonly dataClassificationTags: ReadonlyArray<string | null>;
  readonly homepage: {
    readonly id: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly icon: {
    readonly path: string;
  } | null;
  readonly id: string | null;
  readonly key: string | null;
  readonly name: string | null;
  readonly spaceTypeSettings?: {
    readonly enabledContentTypes: {
      readonly isDatabasesEnabled: boolean;
      readonly isLivePagesEnabled: boolean;
      readonly isSlidesEnabled: boolean;
      readonly isWhiteboardsEnabled: boolean;
    };
  };
  readonly type: string | null;
  readonly " $fragmentType": "SpaceDetail_space";
};
export type SpaceDetail_space$key = {
  readonly " $data"?: SpaceDetail_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceDetail_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "type"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeSpaceTypeSettings"
    }
  ],
  "kind": "Fragment",
  "name": "SpaceDetail_space",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "dataClassificationTags"
    },
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "homepage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "title"
        },
        (v1/*: any*/)
      ]
    },
    {
      "concreteType": "Icon",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        }
      ]
    },
    {
      "condition": "includeSpaceTypeSettings",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SpaceTypeSettings",
          "kind": "LinkedField",
          "name": "spaceTypeSettings",
          "plural": false,
          "selections": [
            {
              "concreteType": "EnabledContentTypes",
              "kind": "LinkedField",
              "name": "enabledContentTypes",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "isLivePagesEnabled"
                },
                {
                  "kind": "ScalarField",
                  "name": "isWhiteboardsEnabled"
                },
                {
                  "kind": "ScalarField",
                  "name": "isDatabasesEnabled"
                },
                {
                  "kind": "ScalarField",
                  "name": "isSlidesEnabled"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Space"
};
})();

(node as any).hash = "eba0e6a9e61153ecb445e3b3118dc653";

export default node;
